// extracted by mini-css-extract-plugin
export default {"SelectableCardBody":"SelectableCardBody_SelectableCardBody__KzcE2"};